// const color = {
//     green: "#4cceac",
//     buttonGreen: "#3da58a",
//     red: "#ee0707",
//     blue: "#0c62b3",
//     orange: '#ffa500',
//     white: "#e0e0e0",
//     darkblue: "#0c0a8b",
//     darkgreen: "#088819",
//     sidebarColor: '#1F2A40',
//     backgroundColor: '#1f4024',
//     tableColor:  "#1F2A40",
//     tableTextColor: "#e0e0e0",
//     iconSidebarColor: "#e0e0e0",
//     sidebartitleColor: "#e0e0e0",
//     sidebarItemhover: "#3e4396",
//     nameAvatarColor: "#70d8bd",
//     inputTextColor:  "#fff",
//     labeloutLinedColor: "#e0e0e0",
//     headColor:'#3e4396',
//     MainBackground:  "#141b2d",
// }


// export default color;



const color = {
    green: "#1f4024",
    buttonGreen: "#3da58a",
    red: "#ee0707",
    blue: "#0c62b3",
    orange: '#ffa500',
    white: "#e0e0e0",
    darkblue: "#0c0a8b",
    darkgreen: "#088819",
    sidebarColor: '#fff',
    backgroundColor: '#1f4024',
    tableColor:  "#fff",
    tableTextColor: "black",
    iconSidebarColor: "#1f4024",
    sidebartitleColor: "#1f4024",
    sidebarItemhover: "#ccc",
    nameAvatarColor: "#1f4024",
    inputTextColor:  "black",
    labeloutLinedColor: "#1f4024",
    headColor:'#fff',
    MainBackground:  "#e2e3e4", ///141b2d

}


export default color;